import { Currency } from '../../constants/currency.js';
import { getMaxAmount, generateTermRange, humanizeTermRange, getAmountRangeToString } from '../../helpers/humanization.js';

// eslint-disable-next-line max-statements
const getBankGuaranteesTerms = item => {
    // Сумма, Срок, Комиссия, без залога
    const conditions = [];
    // сумма
    const { minSum, maxSum } = item;
    const amount = getMaxAmount({ from: minSum, to: maxSum }, { postfix: ' ₽', isConvert: true }, 'По согласованию');
    conditions.push({ value: amount, description: 'Сумма гарантии', wide: true, key: 'amount' });
    // срок
    const { dictDateFrom, dictDateTo, maxTime, minTime } = item;
    if (dictDateFrom && dictDateTo && maxTime && minTime) {
        const termRange = generateTermRange({ dictDateFrom, dictDateTo, to: maxTime, from: minTime });
        const term = humanizeTermRange(termRange, { initialForm: false }, 'Индивидуально');
        conditions.push({ value: term, description: 'Срок', wide: true, key: 'term' });
    }
    // комиссия
    let comission = '';
    const { comissionTakeToRub, comissionTakeFromRub, maxRate, minRate } = item;
    if (maxRate || minRate) {
        const rate = { from: minRate, to: maxRate };
        comission = getAmountRangeToString({
            amountRange: rate,
            currency: Currency.PROCENT,
            defaultText: 'Индивидуально',
            prefix: true,
            isFloat: true,
        });
    }
    else if (comissionTakeToRub || comissionTakeFromRub) {
        const comissionRange = { from: comissionTakeFromRub, to: comissionTakeToRub };
        comission = getAmountRangeToString({
            amountRange: comissionRange,
            currency: Currency.RUB,
            defaultText: 'Индивидуально',
            prefix: true,
        });
    }
    else {
        const { minRate, maxRate } = item;
        const rate = { from: minRate, to: maxRate };
        comission = getAmountRangeToString({
            amountRange: rate,
            currency: Currency.PROCENT,
            defaultText: 'Индивидуально',
            prefix: true,
            isFloat: true,
        });
    }
    conditions.push({ value: comission, description: 'Комиссия', key: 'comission' });
    // без залога
    const noSecurity = item.advantages?.includes('noSecurity');
    noSecurity && conditions.push({ value: 'Да', description: 'Без залога', key: 'zalog' });
    return conditions;
};

export { getBankGuaranteesTerms };
//# sourceMappingURL=bankGuarantees.js.map
